import { useEffect, useState } from 'react';
import { topNavFallbackData } from '../constants';
import { getServerUrl } from '../utils/getServerUrl';
import { isEmptyObject } from '../utils/isEmptyObject';
export const useTopNav = (zapidentity) => {
    const [isLoading, setIsLoading] = useState(true);
    const [topNav, setTopNav] = useState(topNavFallbackData);
    useEffect(() => {
        let apiSubscribed = true;
        async function getTopnavData() {
            const serverUrl = getServerUrl();
            const topnavUrl = `${serverUrl}/navigation-data/topbar`;
            const fetchData = {
                headers: { 'x-zapidentity-id': zapidentity.toString() },
            };
            try {
                setIsLoading(true);
                const response = await fetch(topnavUrl, fetchData);
                if (!response.ok) {
                    throw new Error('Response was not OK');
                }
                if (apiSubscribed) {
                    const json = await response.json();
                    const { data } = json;
                    if (!isEmptyObject(data))
                        setTopNav(data);
                }
            }
            catch (error) {
                if (apiSubscribed) {
                    setTopNav(topNavFallbackData);
                }
            }
            finally {
                if (apiSubscribed) {
                    setIsLoading(false);
                }
            }
        }
        getTopnavData();
        return () => {
            apiSubscribed = false;
        };
    }, [zapidentity]);
    return { isLoading, topNav };
};
//# sourceMappingURL=useTopNav.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
